import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/scss/reset.scss'
import Scrollreveal from 'scrollreveal'
import i18n from './plugins/i18n'
import commonFun from './plugins/commonFun'
import gsap from './plugins/gsap'
import { buildInfoLogFromArray } from './plugins/console'
import packageJson from '../package.json'

Vue.config.productionTip = false

commonFun()
gsap()
buildInfoLogFromArray([{ key: 'version', val: packageJson.version, color: '#41b883' }])

window.sr = new Scrollreveal()

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
